export const removePreloadFont = (href: string) => {
  const links = document.querySelectorAll(`link[rel="preload"][href="${href}"]`);
  links.forEach((link) => link?.parentNode?.removeChild(link));
};
